import type { ContactIntent } from '@/constants/contact'

export type NavIcon =
    | 'full-service'
    | 'studio'
    | 'pilot'
    | 'one-api'
    | 'blog'
    | 'changelog'
    | 'embedded'
    | 'platform-api'

export interface NavItem {
    title: string
    description: string
    icon: NavIcon
    href?: string
    intent?: ContactIntent
}

export interface NavGroup {
    label: string
    items: Array<NavItem>
}

export const productLinks: Array<NavItem> = [
    { title: "Full-Service Integrations", description: "Custom integrations, designed and run for you", icon: 'full-service', href: '/full-service' },
    { title: "Studio Builder", description: "Build and automate integrations visually", icon: 'studio', href: '/full-service#build' },
    { title: "Pilot", description: "Automate work with AI", icon: 'pilot', href: '/pilot' },
    { title: "One API", description: "Connect to 4,100+ apps through a single API", icon: 'one-api', href: '/apps' }
]

export const resourceLinks: Array<NavItem> = [
    { title: "Blog", description: "Practical notes on workflow automation", icon: 'blog', intent: 'blog' },
    { title: "Changelog", description: "Everything we have shipped", icon: 'changelog', intent: 'changelog' }
]

export const docsGroups: Array<NavGroup> = [
    {
        label: "Product Documentation",
        items: [
            { title: "Pilot Documentation", description: "Work faster from day one", icon: 'pilot', href: '/pilot#how-it-works' },
            { title: "Studio Documentation", description: "Our low-code workflow platform", icon: 'studio', href: '/full-service#build' },
            { title: "Embedded Documentation", description: "White-labeled integrations inside your product", icon: 'embedded', href: '/apps#connect' }
        ]
    },
    {
        label: "API Documentation",
        items: [
            { title: "One API", description: "Connect to 4,100+ apps", icon: 'one-api', href: '/apps' },
            { title: "FlowCraft API", description: "Manage platform resources", icon: 'platform-api', href: '/apps#depth' }
        ]
    }
]

export interface FooterLink {
    label: string
    href?: string
    intent?: ContactIntent
}

export interface FooterColumn {
    title: string
    links: Array<FooterLink>
}

export const footerColumns: Array<FooterColumn> = [
    {
        title: "Products",
        links: [
            { label: "Pilot", href: '/pilot' },
            { label: "Studio", href: '/full-service#build' },
            { label: "One API", href: '/apps' },
            { label: "Embedded integrations", href: '/apps#connect' },
            { label: "Full-service integrations", href: '/full-service' },
            { label: "Apps directory", href: '/apps' }
        ]
    },
    {
        title: "Solutions",
        links: [
            { label: "CRM Integration", href: '/apps?category=crm#directory' },
            { label: "E-Commerce Integration", href: '/apps?category=commerce-platforms#directory' },
            { label: "Field-Service integrations", href: '/apps?category=field-service#directory' },
            { label: "NetSuite integrations", href: '/full-service?app=netsuite#showcase' },
            { label: "Salesforce integrations", href: '/full-service?app=salesforce#showcase' },
            { label: "HubSpot integrations", href: '/full-service?app=hubspot#showcase' },
            { label: "QuickBooks integrations", href: '/full-service?app=quickbooks#showcase' }
        ]
    },
    {
        title: "Company",
        links: [
            { label: "About", href: '/full-service#story' },
            { label: "Blog", intent: 'blog' },
            { label: "Contact", intent: 'contact' },
            { label: "Speak to a human", intent: 'human' },
            { label: "Status", href: '/status' },
            { label: "Partner with FlowCraft", intent: 'partner' },
            { label: "Trust Center", href: '/trust' },
            { label: "Privacy Policy", href: '/privacy-policy' },
            { label: "Terms of Service", href: '/terms-of-service' },
            { label: "Terms of Use", href: '/terms-of-use' }
        ]
    }
]
